import updateFolder from './updateFolder';
import FolderInfoResponseMessage from 'owa-service/lib/contract/FolderInfoResponseMessage';
import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import setFolderField from 'owa-service/lib/factory/setFolderField';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import Permissions from 'owa-service/lib/contract/Permissions';
import folder from 'owa-service/lib/factory/folder';

/**
 * This service command is used to save folder permissions on server.
 * @param folderId folder id for which folder permissions needs to be fetched.
 * @param permissionSet new permission set that needs to be saved at server.
 * @returns Promise object
 */
export default function(
    folderId: string | DistinguishedFolderIdName,
    permissionSet: Permissions
): Promise<FolderInfoResponseMessage> {
    return updateFolder(folderId, [
        setFolderField({
            Path: propertyUri({
                FieldURI: 'PermissionSet',
            }),
            Folder: folder({
                PermissionSet: permissionSet,
            }),
        }),
    ]);
}
